import { memo } from 'react';
import {
    Grid,
    Box
} from "@mui/material";
import WebhookMain from '../components/webhooks/WebhookMain';

const WebhookConfiguration = props =>  {
    return (
      <>
        <Grid item xs={12} className="mg-t-20">
          <h2>Configuraciones Webhooks</h2>
        </Grid>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <WebhookMain />
        </Box>
      </>
    );

}

export default memo(WebhookConfiguration);
